import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { DateTime } from 'luxon';
import { FormattedMessage } from 'react-intl';

import { modelOf } from '../../../../prop-types';
import CustomerUserStore from '../../../../store/CustomerUserStore';
import ContentForState from '../../../loader/ContentForState';

@observer
export class BalanceUserPinCode extends Component {
  getPinData = () => {
    const { pinData } = this.props;

    return (
      <div className="BalanceUserPinCode">
        <div className="BalanceUserPinCode__pin-code">
          {pinData && pinData.pin}
        </div>
        <div className="BalanceUserPinCode__pin-expiry">
          {pinData && (
            <FormattedMessage
              id="myAccount.pinExpires"
              defaultMessage="PIN-code expires at {expires}. Time is now {nowTime} "
              values={{
                expires: DateTime.fromISO(pinData.expires).toLocaleString(
                  DateTime.TIME_24_WITH_SECONDS
                ),
                nowTime: DateTime.local().toLocaleString(
                  DateTime.TIME_24_WITH_SECONDS
                )
              }}
            />
          )}
        </div>
      </div>
    );
  };

  render() {
    const { customerUserStore, pinState } = this.props;

    return (
      <ContentForState
        state={pinState}
        error={customerUserStore.lastError}
        forLoaded={() => this.getPinData()}
      />
    );
  }
}

BalanceUserPinCode.propTypes = {
  customerUserStore: modelOf(CustomerUserStore).isRequired,
  pinState: PropTypes.string.isRequired,
  pinData: PropTypes.shape({
    expires: PropTypes.string,
    pin: PropTypes.string
  })
};

export default inject('apiWrapper', 'customerUserStore')(BalanceUserPinCode);



// WEBPACK FOOTER //
// ./src/components/my-account/BalanceUser/BalanceUserPinCode/index.jsx